// autogenerated, do not modify

export default {
  "Axios.ConnectionError": "Нет соединения с сетью. Пожалуйста, проверьте подключение и настройку точки доступа в Интернет (APN: “internet”).",
  "Axios.Error": "Ошибка {status}",
  "Axios.ServerError": "Что-то пошло не так. Мы уже работаем над исправлением, попробуйте ещё раз.",
  "Axios.TimeoutError": "Время ожидания истекло. Пожалуйста, попробуйте еще раз.",
  "Common.Activate": "Подключить",
  "Common.Activated": "Подключено",
  "Common.AddNumberForSMS": "Добавить MTX Number",
  "Common.Attention": "Внимание!",
  "Common.Back": "Назад",
  "Common.Balance": "Пополнить",
  "Common.CNY": "CNY",
  "Common.Cancel": "Отмена",
  "Common.Close": "Закрыть",
  "Common.ContactSupport": "Свяжитесь с поддержкой",
  "Common.Date": "Дата",
  "Common.Deactivate": "Отключить",
  "Common.Delete": "Удалить",
  "Common.Duration": "Время действия",
  "Common.ESIM": "eSIM",
  "Common.EUR": "€",
  "Common.Europe": "Европа",
  "Common.Everywhere": "Мир",
  "Common.Friday": "Пт",
  "Common.IdentityUnverified": "Вам необходимо загрузить фотографию своего удостоверения личности (паспорт, национальный документ или водительское удостоверение). Прежде чем вы сможете начать пользоваться сервисом, дождитесь проверки и одобрения вашего документа.",
  "Common.IdentityWanted": "Вам необходимо загрузить фотографию своего удостоверения личности (паспорт, национальный документ или водительское удостоверение)",
  "Common.IdentityWantedFlashMessage": "Вам необходимо <a href=\"{link}\">загрузить</a> фотографию своего удостоверения личности (паспорт, национальный документ или водительское удостоверение)",
  "Common.Loading": "Загрузка...",
  "Common.Login": "Логин",
  "Common.MB": "МБ",
  "Common.Mb": "Мб",
  "Common.Monday": "Пн",
  "Common.Name": "Имя",
  "Common.Next": "Далее",
  "Common.NoData": "нет данных",
  "Common.Ok": "Хорошо",
  "Common.Package": "Пакет",
  "Common.Price": "Цена",
  "Common.SIM": "SIM",
  "Common.Saturday": "Сб",
  "Common.Save": "Сохранить",
  "Common.Simcard": "Sim",
  "Common.Sum": "Сумма",
  "Common.Sunday": "Вс",
  "Common.Thursday": "Чт",
  "Common.Traffic": "Трафик",
  "Common.Tuesday": "Вт",
  "Common.Wednesday": "Ср",
  "Common.day": "д",
  "Common.hour": "ч",
  "Common.minute": "м",
  "Exception.LetUsKnow": "Сообщить",
  "Exception.PageNotFound": "Страница не найдена. 404",
  "Exception.ReturnToHomepage": "Вернуться на главную",
  "Exception.ServerErrorDescription": "Попробуйте снова, если результат тот же, пожалуйста, сообщите нам.",
  "Exception.ServerErrorTitle": "Что-то пошло не так",
  "GDPR.AgreeBtn": "GIVE CONSENT",
  "GDPR.Attention": "Please not that in case you refuse to accept the new Privacy Policy we will not be able to provide you with our Services subject to the new regulations of the European Union.",
  "GDPR.BackLink": "Back to MTX Connect website",
  "GDPR.DisagreeBtn": "Do not give consent",
  "GDPR.Notice": "In accordance with new requirements regarding the data protection in the European Union we are updating {link} in order to protect the privacy of our customers on higher standards and to improve the security of all personal data collected from you. The amendments will help you to understand what information we may collect about you and the reasons why we are doing so; it will also give you an overview on how you can manage, update, delete or export your information.",
  "GDPR.NoticeLink": "our Privacy Policy",
  "GDPR.Request": "We kindly ask you to carefully read {link} and provide us with your consent by clicking the button below.",
  "GDPR.RequestLink": "our amended Privacy Policy",
  "GDPR.VerificationTitle": "Thank you very much for giving us your consent.",
  "History.All": "Все",
  "History.Date": "Дата",
  "History.Details": "Подробно",
  "History.DownloadReceipt": "get receipt",
  "History.EmptyHistory": "Нет данных",
  "History.EndDate": "Дата до",
  "History.StartDate": "Дата от",
  "History.Sum": "Сумма",
  "LogoutButton.Logout": "Выйти",
  "LogoutButton.LogoutCancel": "Отмена",
  "LogoutButton.LogoutConfirmation": "Выйти?",
  "LogoutButton.LogoutYes": "Да",
  "Menu.ActivateSIM": "Новая SIM",
  "Menu.Connect": "Подключиться",
  "Menu.ContactUs": "Контакты",
  "Menu.Coverage": "Карта покрытия",
  "Menu.Faq": "Поддержка",
  "Menu.History": "История",
  "Menu.HowItWorks": "Как это работает",
  "Menu.Overview": "Обзор",
  "Menu.Pricing": "Тарифы",
  "Menu.Profile": "Профиль",
  "Menu.Support": "Техподдержка",
  "Menu.Topups": "Пополнить",
  "OneTIme.PaymentSuccess": "Payment successful.",
  "OneTime.Amount": "Amount",
  "OneTime.EsimSentTo": "eSIM settings were also sent to:",
  "OneTime.OrderID": "Order ID:",
  "OneTime.PaidWith": "Paid with",
  "OneTime.ThankYou": "Thank you for purchasing!",
  "OneTime.WaitingEsim": "Your eSIM installation QR code will be ready in 1-2 minutes",
  "OneTimePassBuyTitle": "You are going to buy One-Time Pass offer: <b>{name}</b>",
  "OneTimePassDescription": "This eSIM is for **one-time use only**. It will deactivate once its package is used up or expires, and it cannot be reused like a regular MTX eSIM.\n\nIt won't be visible in your MTX personal account, meaning you can't manage it there.\n\n\\\n**How to use One-time Pass:**\n1. You will get a QR code.\n2. Scan it with your phone.\n3. Follow the on-screen instructions.",
  "OneTimePassDisclaimerMsg": "New disposable eSIM will be installed. It will deactivate once it's used or expired.",
  "OneTimePassDisclaimerTitle": "ONE-TIME PASS OFFERS",
  "OneTimePassLoadingMsg": "We are looking for available One-Time offers, which can take up to 2 minutes. Please be patient.",
  "OneTimePassMissingCoverage": "We are constantly working to expand our coverage. Unfortunately, we currently do not have One-Time Pass offers in {country}.",
  "Order.Acknowledge": "Подтвердить",
  "Order.Activate": "Активировать сим",
  "Order.ActivationCode": "Код активации",
  "Order.Attention": "Внимание! Вам нужно пополнить баланс для использования этой услуги.",
  "Order.AttentionCanada": "Внимание: услуги MTX Connect не могут использоваться резидентами Канады на территории Канады.",
  "Order.AttentionChina": "Для доставки в Китай необходимо указать номер мобильного телефона и адрес доставки на китайском языке.",
  "Order.CartCaption": "Вы заказали {amount, plural, =0 {# {name} карт} one {# {name} карту} few {# {name} карт} many {# {name} карт} other {# {name} карты}}, сумма к оплате €{price}*",
  "Order.ChooseOption": "Выберите вариант",
  "Order.ChooseType": "Выберите тип сим-карты",
  "Order.CloseBtn": "Закрыть",
  "Order.Continue": "Нажимая кнопку «Далее», я соглашаюсь с <a href=\"https://www.mtxc.eu/en/terms-and-conditions.html\" target=\"_blank\">Условиями обслуживания</a> и <a href=\"https://www.mtxc.eu/en/privacy-policy.html\" target=\"_blank\">Политикой конфиденциальности</a>",
  "Order.DontDeleteEsim": "Внимание! Не удаляйте eSIM, в случае удаления восстановить eSIM невозможно. Профиль может быть деактивирован и подключён для использования позже ",
  "Order.DontDeleteEsimLink": "https://faq.mtxc.eu/ru/article/chto-esli-ya-udalil-svoyu-esim-1hbvu21/?1576593511929",
  "Order.DontDeleteEsimLinkName": "(Подробнее)",
  "Order.ESIMConfirmation": "Я подтверждаю, что моё устройство поддерживает eSIM.",
  "Order.ESIMDescr": "eSIM для вашего eSIM-совместимого устройства за €{price} *",
  "Order.EsimCanProcess": "Получение данных для настройки eSIM может занять до 2 минут.",
  "Order.EsimRequestRateExceeded": "Вы превысили ограничение на один заказ в две минуты. Если вам нужно повторить заказ, пожалуйста, подождите.",
  "Order.EsimSent": "Также данные для настройки eSIM будут отправлены на ваш адрес электронной почты, это окно можно закрыть.",
  "Order.MakeSureEsim": "Обязательно убедитесь что ваш смартфон или ваше устройство поддерживает eSIM! Пожалуйста, проверьте инструкцию от вашего устройства или сверьтесь с сайтом производителя. В случае ошибки вы не сможете воспользоваться сервисом. Эта услуга не подлежит возврату после приобретения.",
  "Order.MaxLengthExceeded": " Поле {fieldName} ограничено {maxLength} символами",
  "Order.New": "Заказать сим",
  "Order.OrderID": "Номер заказа: {orderId}",
  "Order.PaymentDescr": "*Стоимость указана без учета НДС и прочих налогов. Платёж будет списан с вашего баланса MTX Connect.",
  "Order.ProceedWithOrder": "и выполнить заказ",
  "Order.QuotaExceededCheckbox": "Понятно",
  "Order.QuotaExceededConfirmation": "Вы не сможете активировать карту на этот аккаунт, так как у вас уже 10 активных карт. <br /><br />Если вам нужно больше, вы можете создать новый аккаунт либо написать по адресу <a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>. Мы предложим вам оптимальное решение для управления большим количеством карт.",
  "Order.SIMDescr": "3-в-1 сим-карта за €{price} *",
  "Order.SimcardsLimitExceeded": "У вас десять активных карт в личном кабинете.<br /><br />Если вам нужно больше, вы можете создать новый аккаунт либо написать по адресу <a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>. Мы предложим вам оптимальное решение для управления большим количеством карт.",
  "Order.SmdpAddress": "Адрес SM-DP+",
  "Order.SuccPaymentCaption": "Заказ оплачен и принят в работу!",
  "Order.SuccPaymentDescr": "Скоро вам на электронную почту придет письмо с информацией о заказе. {orderCaption}",
  "Order.UnsuccPaymentCaption": "Внимание: ошибка оплаты!",
  "Overview.ForSelectedCard": "Только для выбранной карты",
  "Overviews.Action": "Действие",
  "Overviews.ActivationCodeUsed": "SIM-карта с кодом &laquo;<strong>{code}</strong>&raquo; успешно активирована.",
  "Overviews.ActiveSince": "действует с {date}",
  "Overviews.Date": "Дата",
  "Overviews.Details": "Подробно",
  "Overviews.Left": "осталось",
  "Overviews.NoActivePackage": "не выбран пакет",
  "Overviews.NoAvailableTraffic": "нет доступного трафика",
  "Overviews.NoTimeLeft": "время израсходовано",
  "Overviews.Remain": "ОСТАЛОСЬ",
  "Overviews.RemainOf": "ОСТАЛОСЬ ИЗ {remain}",
  "Overviews.Spent": "израсходовано",
  "Overviews.TrafficLeft": "остаток трафика",
  "Overviews.TrafficUsageHistory": "Потребление трафика",
  "Overviews.UnlimitedTime": "безлимитное время",
  "Overviews.UnlimitedTraffic": "безлимитный трафик",
  "Overviews.UsageHistory": "Движения по счёту",
  "Package.Accept": "Да",
  "Package.Active": "Подключено",
  "Package.AnotherPackageIsActive": "У вас активен тариф {activePackageName}. Вы сможете выбрать новый тариф после окончания действия текущего.",
  "Package.AutomaticRenewal": "Automatic renewal",
  "Package.AvailableCountries": "Доступные страны",
  "Package.AvailableNumbers": "Доступные номера",
  "Package.Back": "Назад",
  "Package.BundlesLoadFailure": "Не удалось загрузить список пакетов",
  "Package.CancelRenewal": "Отменить автопродление",
  "Package.CannotSwitchTariff": "Тариф не может быть активирован",
  "Package.ConfirmActivation": "<div>Хотите подключить пакет <b>{packageName}</b> для сим-карты {cardName}?</div>",
  "Package.ConfirmActivationMobileNumber": "<div>Вы собираетесь активировать <b>MTX Number subscription</b> для SIM-карты {cardName}.</div>",
  "Package.ConfirmActivationSubscription": "<div>Вы подключаете <b>{packageName}</b> для своего аккаунта.<br /><b>Опция FreeChat будет активирована для этой карты: {cardName}.</b><br />Если вы хотите использовать FreeChat на другой карте, нажмите &quot;Нет&quot;, выберите нужную карту и после этого активируйте <b>{packageName}</b>.</div>",
  "Package.ConfirmAgreeCheckbox": "Я понимаю и согласен",
  "Package.ConfirmAgreeText": "MTX Number, предоставленный вам MTX Connect будет автопродлеваться на тот же период, используя средства с вашего баланса. Пожалуйста убедитесь, что у вас достаточно средств на балансе перед окончанием срока действия услуги.\n\nПодтверждая покупку вы соглашаетесь с тем, что MTX Number не заменяет вам стационарный телефонный номер и не может использоваться для связи и получения нотификаций от экстренных служб и, в частности, не позволяет вам звонить в экстренные службы.\n\nУслуга предоставляется на условиях «как есть», это означает, что SMS и звонки из некоторых мобильных сетей, приложений или других сторонних служб могут не дойти до вас. MTX Connect не дает никаких гарантий, явных или подразумеваемых, в отношении пригодности или удобства использования MTX Number. Эта услуга не подлежит возврату после приобретения.",
  "Package.ConfirmAlertConsent": "Пожалуйста подтвердите покупку <b>MTX Number для SIM</b> {cardName}.",
  "Package.ConfirmAndPay": "Подтвердить",
  "Package.ConfirmDeactivation": "<div>Хотите отключить пакет <b>{packageName}</b> для сим-карты {cardName}?</div>",
  "Package.ConfirmDeactivationMobileNumber": "<div>Вы собираетесь отключить <b>MTX Number subscription</b> для SIM-карты {cardName}.</div>",
  "Package.Confirmation": "Подтверждение",
  "Package.ConnectPermanently": "Подключить постоянно",
  "Package.Day": "д",
  "Package.Decline": "Нет",
  "Package.Done": "Готово",
  "Package.EnableAnnualRenewal": "Enable automatic renewal",
  "Package.ExpiresDate": "до {date}",
  "Package.Gb": "Гб",
  "Package.GoingToStartRenewal": "MTX Number, выделенный вам MTX, будет автоматически продлен на тот же период с использованием баланса вашего счета или сохраненной платежной карты. Пожалуйста, убедитесь, что у вас достаточно средств до истечения срока действия номера.",
  "Package.GoingToStopRenewal": "You are going to stop auto-renewal for MTX Number {number}.",
  "Package.Hour": "ч",
  "Package.IdentityIsNotApproved": "Ваш документ не был подтверждён. Пожалуйста, обратитесь в <a href=\"{link}\">поддержку</a>",
  "Package.IncludeVAT": "включая НДС {currency} {difference}",
  "Package.ListIsEmpty": "Нет доступных пакетов, сожалеем",
  "Package.Mb": "Мб",
  "Package.MobileNumberHeader": "ДобавитьMTX Number к вашей сим-карте MTX",
  "Package.MobileNumberHint": "Подключите MTX Number от MTX Connect и принимайте SMS и звонки по всему миру на свою сим-карту MTX.",
  "Package.MobileNumberLabel": "Годовая подписка на услугу входящих СМС и голосовых звонков.",
  "Package.MobileNumberPaymentHint": "Платёж будет списан с вашего баланса MTX Connect.",
  "Package.Number": "Номер",
  "Package.PackageWillBeDeactivated": "<strong>Внимание!</strong> Пакет <strong>{packageName}</strong> будет деактивирован!",
  "Package.PleaseTopup": "Не хватает средств. Пожалуйста, пополните счёт на странице {please_topup_page}",
  "Package.PleaseTopupPage": "Пополнить баланс",
  "Package.PreviousNumbers": "Previous Numbers",
  "Package.SelectNumber": "Select Number",
  "Package.StartRenewal": "Start Renewal",
  "Package.Subscribe": "Подключить",
  "Package.Subscribed": "Подключено",
  "Package.SubscriptionActivationFailure": "Не удалось активировать выбранный пакет. Пожалуйста, повторите попытку позже.",
  "Package.SubscriptionDeactivationFailure": "Не удалось деактивировать выбранный пакет. Пожалуйста, повторите попытку позже.",
  "Package.Topup": "Пополнить",
  "Package.TopupBalance": "Пополнить",
  "Package.TrafficWillBeLost": "<strong>Внимание!</strong> Будет потерян неизрасходованный трафик - {trafficRemain}Мб",
  "Package.Unsubscribe": "Отключить",
  "Package.UnsubscribeWarning": "<p><b>Внимание</b></p>\n<p>Автоматическое продление вашей подписки будет отключено.\nВы можете пользоваться вашей подпиской до окончания её срока действия.\nПосле этого подписка не будет продлена автоматически.</p>",
  "Package.perMb": "за Мб",
  "Profile.ChangePassword": "Изменить пароль",
  "Profile.ChangingPassword": "Изменение пароля...",
  "Profile.ChooseIdentity": "Выбрать файл",
  "Profile.City": "Город",
  "Profile.CityHint": null,
  "Profile.Common": "Общее",
  "Profile.ConfirmNewPassword": "Подтверждение нового пароля",
  "Profile.CopiedToClipboard": "Copied to your clipboard",
  "Profile.Copy": "Скопировать ссылку",
  "Profile.Country": "Страна",
  "Profile.CurrentPassword": "Текущий пароль",
  "Profile.DeliveryAddress": "Адрес доставки",
  "Profile.DeliveryType": "Способ доставки",
  "Profile.DetailedAddress": "Подробный адрес",
  "Profile.District": "Округ",
  "Profile.Email": "Email",
  "Profile.EmailAddress": "Электронный адрес",
  "Profile.FirstName": "Имя",
  "Profile.FirstNameHint": null,
  "Profile.FloorUnit": "Квартира",
  "Profile.FloorUnitHint": null,
  "Profile.GetRefferal": "Получить реферальный код",
  "Profile.IdentityPlaceholder": "Фото паспорта",
  "Profile.IdentityStatus": "Статус",
  "Profile.IdentityStatusAccepted": "Подтверждено",
  "Profile.IdentityStatusLoaded": "Загружено",
  "Profile.IdentityStatusPending": "В ожидании загрузки",
  "Profile.IdentityStatusRejected": "Отклонено",
  "Profile.IdentityStatusUnknown": "Загрузите повторно",
  "Profile.IdentityTitle": "Загрузка документа",
  "Profile.LastName": "Фамилия",
  "Profile.LastNameHint": null,
  "Profile.Login": "Логин",
  "Profile.NewPassword": "Новый пароль",
  "Profile.NoIdentity": "Файл не выбран",
  "Profile.NonLatinError": "Используйте только латинские буквы, цифры и знаки препинания",
  "Profile.PasswordChangeFail": "Не удалось изменить пароль",
  "Profile.PasswordChangeSuccess": "Пароль успешно изменён",
  "Profile.PasswordsDontMatch": "Пароли не совпадают",
  "Profile.Phone1": "Телефон",
  "Profile.PhoneHint": null,
  "Profile.PleaseFillNewPassword": "Пожалуйста, введите новый пароль",
  "Profile.PleaseFillPassword": "Пожалуйста, введите текущий пароль",
  "Profile.Province": "Провинция",
  "Profile.Referral": "Реферальный код",
  "Profile.Region": "Область",
  "Profile.RegionHint": null,
  "Profile.Street": "Улица",
  "Profile.StreetAndNumber": "Улица и номер",
  "Profile.StreetHint": null,
  "Profile.StreetNumber": "Дом",
  "Profile.StreetUnit": "Строение",
  "Profile.StreetUnitHint": null,
  "Profile.TermsOfServices": "Нажимая кнопку «Далее», я соглашаюсь с <a href=\"https://www.mtxc.eu/ru/terms-and-conditions.html\" target=\"_blank\">Условиями обслуживания</a>",
  "Profile.TheCurrentPasswordIsIncorrect": "Текущий пароль указан некорректно",
  "Profile.UpdateFailed": "Не получилось обновить профиль!",
  "Profile.UpdateProfile": "Обновить профиль",
  "Profile.UpdatedSuccessfully": "Профиль был успешно обновлен!",
  "Profile.UpdatingProfile": "Сохраняем изменения...",
  "Profile.UploadingIdentity": "Загрузка:",
  "Profile.ZipCode": "Почтовый индекс",
  "Shared.ActivePackage": "Действующий пакет",
  "Shared.ActiveTill": "активен до {date}",
  "Shared.AddSIM": "Новая SIM",
  "Shared.ApiError": "Произошла ошибка. ",
  "Shared.ApiErrorLink": "Обновите страницу",
  "Shared.Back": "Назад",
  "Shared.BonusPackage": "Бонусный пакет",
  "Shared.CardIsSuspended": "Действие этой SIM-карты приостановлено. Для восстановления карты, пожалуйста, обратитесь в нашу <a href=\"{link}\">клиентскую службу</a>.",
  "Shared.ConnectAndStartUsing": "Подключить интернет",
  "Shared.CurrentPackageIs": "Текущий пакет {packageName} активен до {date}",
  "Shared.ErrorGettingTestSmsCount": "Не удалось получить количество тестовых СМС",
  "Shared.ErrorLoadingPage": "Не удалось загрузить страницу",
  "Shared.ErrorPhoneMsg": "Пожалуйста, используйте корректный номер телефона",
  "Shared.FillAllAddressFields": "Пожалуйста, заполните подсвеченные поля",
  "Shared.Location": "Страна",
  "Shared.NextPackage": "Далее",
  "Shared.PackageToBeActive": "В Европе будет активирован пакет: ",
  "Shared.Rename": "Переименовать",
  "Shared.Sure": "Уверены?",
  "Shared.Suspend": "Приостановить",
  "Shared.TestSmsButton": "Тест SMS",
  "Shared.TestSmsLeft": "Осталось {left} тестовых СМС",
  "Shared.Unsuspend": "Возобновление будет доступно только по запросу на <a href=\"mailto:help@mtxc.eu\">help@mtxc.eu</a>",
  "Shared.UploadError": "Не удалось загрузить файл. Пожалуйста, отправьте его на почту support@mtxc.eu",
  "Shared.UploadWrongFormat": "Файл должен быть в формате jpg",
  "Simcards.ActivateSIM": "Активировать SIM",
  "Simcards.ActivateSimCard": "Активируйте симкарту, чтобы начать пользоваться кабинетом",
  "Simcards.EmptyActivationCode": "Заполните код активации",
  "Simcards.EnterCode": "Пожалуйста, введите код активации",
  "Simcards.ErrorLoadingPrices": "Failed to load prices",
  "Simcards.FindActivationCode": "Код активации расположен на обратной стороне карты MTXC:",
  "Simcards.SimcardNotActivated": "Не удалось активировать сим-карту",
  "Simcards.WrongFormatActivationCode": "Код активации введен неверно",
  "Support.Buffered": "Ваше сообщение успешно отправлено в службу поддержки. Мы обязательно ответим вам. Вы получите ответ в почту/смс и в личный кабинет.",
  "Support.BufferedCn": "Ваше сообщение успешно отправлено в службу поддержки. Мы обязательно ответим вам. Вы получите ответ в почту/смс и в личный кабинет.",
  "Support.CreateCommentError": "Ошибка при создании сообщения. Попробуйте позже или напишите на электронный адрес support@mtxc.eu",
  "Support.CreateTicketError": "Ошибка при создании обращения. Попробуйте позже или напишите на электронный адрес support@mtxc.eu",
  "Support.Date": "Дата",
  "Support.LoadMoreBtn": "Загрузить ещё",
  "Support.Message": "Сообщение",
  "Support.Send": "Отправить",
  "Support.Sending": "Отправляем...",
  "Support.Topic": "Тема",
  "TermsAnPrivacy": "By clicking <b>\"Accept\"</b>, I certify that agree to the <a href=\"{terms_url}\" target=\"_blank\"><b>Terms and Conditions</b></a> and <a href=\"{privacy_url}\" target=\"_blank\"><b>Privacy Policy</b></a>.",
  "Topup.AliPay": "AliPay",
  "Topup.AliPayRedirecting": "Переходим на AliPay...",
  "Topup.AliPayWarning": "При оплате Alipay подтверждение платежа может занять до 24 часов.<br />Выберите другой вариант оплаты, если вам важна быстрая обработка заказа.",
  "Topup.Amount": "Сумма пополнения",
  "Topup.AmountTitle": "Top-up amount, €",
  "Topup.AmountWord": "Сумма ${amount} ${currency}",
  "Topup.ApplePayBtn": "Оплатить с",
  "Topup.ByCard": "Карта",
  "Topup.CVC": "CVC",
  "Topup.CardCvv": "Please enter CVV:",
  "Topup.CardDetails": "Card details:",
  "Topup.CardHolderName": "CARDHOLDER NAME",
  "Topup.CardNew": "New card",
  "Topup.CardNumber": "Номер карты",
  "Topup.CardSaved": "Saved cards",
  "Topup.EnterVoucherCode": "Введите код ваучера",
  "Topup.ExchangeNotice": "Сумма начисленния может отличаться в зависимости от обменного курса. Если вы видите какое-либо несоответствие, обратитесь в нашу службу поддержки.",
  "Topup.GettingToken": "Получаем токен...",
  "Topup.InsufficientFunds": "Insufficient funds",
  "Topup.MM": "MM",
  "Topup.MakePayment": "Оплатить",
  "Topup.Megapay": "MEgapay",
  "Topup.PaidWith": "Оплачено {paymentMethod}",
  "Topup.PayByVoucher": "Оплатить ваучером",
  "Topup.PayPal": "PayPal",
  "Topup.PayPalPayment": "Оплатить используя PayPal",
  "Topup.PayPalProceed": "Оплатить {amount} {currency_code} используя PayPal",
  "Topup.PaymentInProgress": "Оплата в процессе...",
  "Topup.RefillCard": "Не удалось совершить платеж. Пожалуйста, введите данные вашей карты еще раз. Мы сменили платежный шлюз и нужно снова привязать карту, чтобы пополнить счет.",
  "Topup.RememberCard": "Запомнить эту карту",
  "Topup.Saving": "Сохранение...",
  "Topup.SpecifyAddress": "Заполните платёжный адрес",
  "Topup.StoredCard.EnterCVV": "Введите CCV код",
  "Topup.StoredCard.Pay": "Оплатить",
  "Topup.StoredCard.StoredCards": "Сохранённые карты",
  "Topup.StoredCard.UseCard": "Оплатить этой картой",
  "Topup.SubmittingCode": "Отправляем код...",
  "Topup.SuccessfulPaymentDescrEmail": "Вы получите письмо с подтверждением на ваш E-mail.",
  "Topup.SuccessfulPaymentDescrSMS": "Вы получите письмо с подтверждением по SMS.",
  "Topup.SuccessfulPaymentHeader": "Платеж прошел успешно, ваш заказ принят в обработку.",
  "Topup.SuccessfulPaymentPayAgain": "Оплатить еще",
  "Topup.SuccessfulPaymentTransaction": "Номер транзакции: {transactionId}",
  "Topup.SuccessfulPaymentTryAgain": "Пожалуйста, повторите попытку",
  "Topup.TakeCareText": "Мы заботимся о безопасности наших клиентов и не храним реквизиты вашей карты.",
  "Topup.UnsuccessfulPaymentHeader": "Внимание! Во время оплаты произошли ошибки!",
  "Topup.UseCardToAutoSubscriptionRenewal": "Use this card for automatic subscription renewal if there are insufficient funds",
  "Topup.UseCardToAutoTopup": "Use this card for automatic top-up when the balance falls below €2",
  "Topup.ValidThru": "Срок действия",
  "Topup.Voucher": "Ваучер",
  "Topup.YY": "YY",
  "autorenew.subscription.disable": "Вы собираетесь отключить автоматическое продление подписки {name}.",
  "autorenew.subscription.enable": "Подписка {name} будет автоматически продлена на тот же период с использованием баланса вашего счета или сохраненной платежной карты. Пожалуйста, убедитесь, что у вас достаточно средств до истечения срока действия подписки.",
}



// WEBPACK FOOTER //
// ./app/javascript/components/locales/ru.js